export const LocationNameValid = {
  locationName: false,
}